import { Component } from '@angular/core';

@Component({
    selector: 'button-add-item',
    templateUrl: 'button-add-item.component.html',
    styleUrls: ['button-add-item.component.less'],
})
export class ButtonAddItemComponent {}
